export const Logo = ({ size = 38 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" data-testid="brand-logo">
    <rect width="64" height="64" rx="14" fill="#0B0B0E" />
    <rect x="2" y="2" width="60" height="60" rx="12" fill="none" stroke="#6EE7B7" strokeOpacity="0.35" strokeWidth="1.5" />
    <rect x="14" y="26" width="5" height="12" rx="2.5" fill="#6EE7B7" />
    <rect x="23" y="16" width="5" height="32" rx="2.5" fill="#A7F3D0" />
    <rect x="32" y="22" width="5" height="20" rx="2.5" fill="#6EE7B7" />
    <rect x="41" y="30" width="5" height="8" rx="2.5" fill="#34D399" />
  </svg>
);
